<template>
  <section class="page-otcRelease a-5-bg">
    <div class="page-otcRelease-coneent">
      <vue-scroll>
        <div class="page-otcRelease-bar">
          <!-- 选择币种 -->
          <div class="otcRelease-symbolNav a-3-bd">
            <c-navTab
              activeClassName="b-1-cl"
              activeColor="a-12-bg"
              className="b-2-cl"
              :currentTab="symbol"
              :navTab="navSymbolList"
              lineHeight="40"
              marginRight="64"
              @currentType="symbolChange"
            />
          </div>
          <!-- 介绍 -->
          <div class="otcRelease-message gray-10-bd">
            <!-- 发布一个交易广告 -->
            <div class="otcRelease-message-title main-cl">
              {{ $t("otcRelease.title") }}
              -
              {{ showCoin }}
            </div>
            <div class="otcRelease-message-text">
              <div class="left">
                <p class="text">{{ $t("otcRelease.text1") }}</p>
                <p class="text">{{ $t("otcRelease.text2") }}</p>
                <p class="text">{{ $t("otcRelease.text3") }}</p>
                <p class="text">{{ $t("otcRelease.text4") }}</p>
                <p class="text">{{ $t("otcRelease.text5") }}</p>
              </div>
              <div class="right">
                <!-- <svg-icon icon-class="ad-bg"></svg-icon> -->
              </div>
            </div>
          </div>
          <!-- 主体 -->
          <div class="otcRelease-main">
            <!-- 广告类型  出售/购买 -->
            <div class="otcRelease-side">
              <!-- 广告类型 -->
              <span class="otcRelease-page otcRelease-page-side main-cl">
                {{ $t("otcRelease.type") }}
              </span>
              <span class="otcRelease-side-even otcRelease-side-first">
                <c-redio name="SELL" :value="side === 'SELL'" @click="sideChange" />
                <!-- 出售 -->
                <span class="text main-cl" @click="sideChange('SELL')">
                  {{ $t("otcRelease.sell") }}
                </span>
              </span>
              <span class="otcRelease-side-even">
                <c-redio name="BUY" :value="side === 'BUY'" @click="sideChange" />
                <!-- 购买 -->
                <span class="text main-cl" @click="sideChange('BUY')">
                  {{ $t("otcRelease.buy") }}
                </span>
              </span>
            </div>
            <div class="flexWrap">
              <!-- 法币类型 -->
              <div class="otcRelease-legalCurrency">
                <c-select
                  :value="legalCurrency"
                  :promptText="$t('otcRelease.currency')"
                  @onChanges="legalCurrencyChange"
                  name="legalCurrency"
                  :errorHave="true"
                  :errorFlag="false"
                  :errorText="$t('otcRelease.currencyError')"
                  :options="legalCurrencyList"
                  newStyleFormat
                />
              </div>
              <!-- 数量 -->
              <div class="otcRelease-number">
                <c-inputLine
                  name="number"
                  :value="number"
                  :promptText="$t('otcRelease.volume')"
                  :warningText="
                    side === 'SELL'
                      ? `${$t('otcRelease.Surplus')} ${
                          otcRateFlag ? blance : numberValue
                        } ${showCoin}`
                      : ''
                  "
                  :errorHave="true"
                  :errorText="numberObj.errorText"
                  :errorFlag="numberObj.errorFlag"
                  @onchanges="inputLineChange"
                  newStyleFormat
                >
                  <span class="otcRelease-input-page b-1-cl">{{ showCoin }}</span>
                </c-inputLine>
              </div>
            </div>
            <!-- 订单服务国家地区 -->
            <div class="otcRelease-legalCurrency">
                <c-select
                  :value="countryCode"
                  :promptText="$t('otcRelease.countryType')"
                  @onChanges="countryCurrencyChange"
                  name="countryCode"
                  :errorHave="true"
                  :errorFlag="false"
                  :errorText="$t('otcRelease.countryError')"
                  :options="countryList"
                  newStyleFormat
                />
              </div>
            <!-- 当前单价 -->
            <div class="otcRelease-NowPrice">
              <div class="otcRelease-page otcRelease-NowPrice-side">
                <!-- 市场参考价 -->
                {{ $t("otcRelease.CurrentUnitPrice") }}
                <a class="des-icon" href="javascript:;">
                  <svg-icon class="icon icon-14" icon-class="rechargeTips"></svg-icon>
                  <span class="gray-10-bg main-cl">
                    {{ $t("otcRelease.des") }}
                  </span>
                </a>
              </div>
              <div class="otcRelease-NowPrice-message">
                <!-- 价格 -->
                <span class="price main-cl">{{ nowPrice }} {{ legalCurrency }}</span>
                <!-- 参考网址 -->
                <!-- <span class="address">
                  ({{ $t('otcRelease.ReferenceWebSite') }}
                  <a class="b-4-cl" target="_blank" :href="rateUrl">{{rateUrl}}</a>)
                </span>-->
              </div>
            </div>

            <div class="flexWrap">
              <!-- 定价方式 -->
              <div class="otcRelease-pricingMethod">
                <c-select
                  :value="pricingMethod"
                  :promptText="$t('otcRelease.PricingMethod')"
                  @onChanges="pricingMethodChange"
                  name="pricingMethod"
                  :errorHave="true"
                  :errorFlag="false"
                  :errorText="$t('otcRelease.PricingMethodError')"
                  :options="pricingMethodList"
                  newStyleFormat
                />
              </div>
              <!--溢价方向-->
              <div class="otcRelease-pricingMethod" v-if="pricingMethod === '1'">
                <c-select
                  :value="pricentMethod"
                  :promptText="$t('otcRelease.precentWay')"
                  @onChanges="precentMethodChange"
                  name="precentMethod"
                  :errorHave="false"
                  :errorFlag="false"
                  :options="pricentMethodList"
                  newStyleFormat
                />
              </div>
            </div>

            <!--溢价百分比-->
            <div class="otcRelease-minPrice precentInput" v-if="pricingMethod === '1'">
              <c-inputLine
                name="precent"
                :value="precent"
                :errorHave="true"
                :errorFlag="precentObj.errorFlag"
                :errorText="precentObj.errorText"
                @onchanges="inputLineChange"
                :promptText="$t('otcRelease.precent')"
                newStyleFormat
              >
                <span class="otcRelease-input-page">%</span>
              </c-inputLine>
            </div>

            <div class="flexWrap otcRelease-sum-area">
              <!-- 单价 -->
              <div class="otcRelease-sum MessPrice" v-if="pricingMethod === '1'">
                <div class="otcRelease-page">{{ $t("otcDetailOrder.MessPrice") }}</div>
                <div class="otcRelease-sum-price b-1-cl">
                  {{ precentPrice }} {{ legalCurrency }}
                </div>
              </div>
              <!-- 总金额 -->
              <div class="otcRelease-sum">
                <div class="otcRelease-page">{{ $t("otcRelease.TotalSum") }}</div>
                <div class="otcRelease-sum-price b-1-cl">{{ sum }} {{ legalCurrency }}</div>
              </div>
            </div>

            <!-- 自定义价格 -->
            <div class="otcRelease-autoPrice" v-if="pricingMethod === '2'">
              <c-inputLine
                name="autoPrice"
                :value="autoPrice"
                :errorHave="true"
                :errorFlag="autoPriceObj.errorFlag"
                :errorText="autoPriceObj.errorText"
                @onchanges="inputLineChange"
                :promptText="$t('otcRelease.CustomPrice')"
                newStyleFormat
              >
                <span class="otcRelease-input-page">{{ legalCurrency }}</span>
              </c-inputLine>
            </div>

            <div class="flexWrap">
              <!-- 最小限额 -->
              <div class="otcRelease-minPrice">
                <c-inputLine
                  name="minPrice"
                  :value="minPrice"
                  :errorHave="true"
                  :errorFlag="minPriceObj.errorFlag"
                  :errorText="minPriceObj.errorText"
                  @onchanges="inputLineChange"
                  :promptText="$t('otcRelease.MinimumQuota')"
                  newStyleFormat
                >
                  <span class="otcRelease-input-page">{{ legalCurrency }}</span>
                </c-inputLine>
              </div>
              <!-- 最大限额 -->
              <div class="otcRelease-maxPrice">
                <c-inputLine
                  name="maxPrice"
                  :value="maxPrice"
                  :errorHave="true"
                  :errorFlag="maxPriceObj.errorFlag"
                  :errorText="maxPriceObj.errorText"
                  @onchanges="inputLineChange"
                  :promptText="$t('otcRelease.MaximumQuota')"
                  newStyleFormat
                >
                  <span class="otcRelease-input-page">{{ legalCurrency }}</span>
                </c-inputLine>
              </div>
            </div>

            <div class="flexWrap">
              <!-- 付款时限 -->
              <div class="otcRelease-tradeTime">
                <c-inputLine
                  name="tradeTime"
                  :value="tradeTime"
                  :errorHave="true"
                  :errorFlag="tradeTimeObj.errorFlag"
                  :errorText="tradeTimeObj.errorText"
                  @onchanges="inputLineChange"
                  :promptText="$t('otcRelease.TimeLimitForPayment')"
                  newStyleFormat
                >
                  <!-- 分钟 -->
                  <span class="otcRelease-input-page">{{ $t("otcRelease.min") }}</span>
                </c-inputLine>
              </div>
              <!-- 对方最少交易次数 -->
              <div class="otcRelease-frequency">
                <c-inputLine
                  name="frequency"
                  :value="frequency"
                  :errorHave="true"
                  @onchanges="inputLineChange"
                  :promptText="$t('otcRelease.MinimumNumber')"
                  newStyleFormat
                >
                  <!-- 次 -->
                  <span class="otcRelease-input-page">{{ $t("otcRelease.frequency") }}</span>
                </c-inputLine>
              </div>
            </div>

            <!-- 失效时间 -->
            <div class="otcRelease-days">
              <c-select
                :value="days"
                :promptText="$t('otcRelease.FailureTime')"
                @onChanges="daysChange"
                name="days"
                :errorHave="true"
                :errorFlag="false"
                :errorText="$t('otcRelease.FailureTimeError')"
                :options="daysList"
                newStyleFormat
              />
            </div>

            <!-- 支付方式 -->
            <div class="otcRelease-pays" v-if="side === 'BUY'">
              <div class="otcRelease-page">
                <!-- 支付方式 -->
                {{ $t("otcRelease.PaymentMethod") }}
                <!-- 最多可选择3种付款方式 -->
                ({{ $t("otcRelease.PaymentMethodWarning") }})
              </div>
              <ul class="otcRelease-paysList">
                <li v-for="(item, index) in buyPaysList" :key="index">
                  <c-checkBox
                    @click="buyPayClick(item)"
                    :value="myBuyPaysList.indexOf(item.id) !== -1"
                  />
                  <c-otcPayIcon @click="buyPayClick(item)" :imgUrl="item.icon" />
                  <span class="paysList-text" @click="buyPayClick(item)">{{handlePayMethodContent(item)}}</span>
                </li>
              </ul>
            </div>

            <!-- 收款方式 -->
            <div class="otcRelease-pays" v-if="side === 'SELL'">
              <!-- 收款方式 -->
              <div class="otcRelease-page">
                {{ $t("otcRelease.Receivables") }}
                <!-- 可选择多种收款方式 -->
                ({{ $t("otcRelease.ReceivablesWarning") }})
              </div>
              <ul class="otcRelease-paysList" v-if="sellPaysList.length">
                <li v-for="(item, index) in sellPaysList" :key="index">
                  <c-checkBox
                    @click="sellPayClick(item)"
                    :value="mySellPaysList.indexOf(item.id) !== -1"
                  />
                  <c-otcPayIcon @click="sellPayClick(item)" style="font-size: 22px;" :imgUrl="item.icon" :payment="item.payment" />
                  <span
                    @click="sellPayClick(item)"
                    class="paysList-text"
                  >
                    {{handlePayMethodContent(item)}}
                  </span>
                </li>
              </ul>
              <!-- 您还没有收款方式，请前往个人中心设置 -->
              <div class="noPay b-4-cl" @click="goNoPay" v-else>
                {{ $t("otcRelease.PaymentError") }}
              </div>
            </div>

            <!-- 自动回复 -->
            <c-inputLine
              name="reply"
              maxLength="500"
              marginTop="20px"
              width="100%"
              :value="reply"
              :errorHave="true"
              @onchanges="inputLineChange"
              :warningText="`${reply.length}/500`"
              newStyleFormat
              className="otcReleaseInputLine"
              :promptText="$t('otcRelease.AutomaticRecovery')"
            />

            <!-- 广告留言 -->
            <c-inputLine
              name="leavingText"
              maxLength="500"
              marginTop="30px"
              width="100%"
              :value="leavingText"
              :errorHave="true"
              @onchanges="inputLineChange"
              :warningText="`${leavingText.length}/500`"
              newStyleFormat
              className="otcReleaseInputLine"
              :promptText="$t('otcRelease.AdvertisingMessage')"
            />

            <div class="buttonContainerArea">
              <c-button
                type="solid"
                paddingW="31px"
                height="40px"
                width="447px"
                style="font-size:14px;"
                @click="confirm"
                :loading="confirmLoading"
                :disabled="confirmDisabled"
              >
                {{ $t("otcRelease.submit") }}
              </c-button>
            </div>

            <c-otcReminder />
            <c-dialog
              :showFlag="successDialogFlag"
              :titleText="$t('otcRelease.Reminder')"
              @confirm="successDialogConfirm"
              @close="successDialogClose"
              :confirmText="$t('otcRelease.AnotherOne')"
              :closeText="$t('otcRelease.goHall')"
            >
              <!-- 恭喜您，广告发布成功。 -->
              <div class="success-dialog">{{ $t("otcRelease.success") }}</div>
            </c-dialog>
          </div>
          <c-verifyCationc-alert
            :showFlag="jurisdictionObj.flag"
            :imgMap="imgMap"
            :titleText="$t('otcRelease.SafetyTips')"
            :detaText="jurisdictionObj.str"
            :dataList="jurisdictionObj.data"
            :buttonText="jurisdictionObj.btnText"
            @confirm="alertConfirm"
            @close="alertClose"
          />
        </div>
      </vue-scroll>
    </div>
  </section>
</template>
<script>
import {
  fixD, fixInput, imgMap, getCoinShowName,
} from '@/utils';

export default {
  data() {
    return {
      imgMap,
      jurisdictionObj: {
        data: [], // 数据
        str: '', // 文案
        statusKey: '', // 当前跳转状态
        flag: false, //
        btnText: '', // 确定按钮
        btnLink: '', // 确认文案
        pass: true,
      },
      accountList: [], // 资产列表
      symbol: null, // 当前币种
      symbolList: [], // 币种列表
      side: '', // SELL出售 BUY购买
      legalCurrency: '', // 法币币种
      legalCurrencyList: [], // 法币select框
      number: '', // 数量
      pricingMethod: '1', // 定价方式
      pricentMethod: '1',
      barNum: 0, // 溢价滚动条
      autoPrice: '', // 自定义价格
      rates: null, // 法币汇率
      minPrice: '', // 最小限额
      maxPrice: '', // 最大限额
      tradeTime: '10', // 付款时限
      frequency: '0', // 交易次数
      days: '30', // 失效时间
      buyPaysList: [], // 支付方式 (购买时)
      sellPaysList: [], // 收款方式 (出售时)
      myBuyPaysList: [], // 选择的支付方式
      mySellPaysList: [], // 选择的收款方式
      confirmLoading: false, // 提交按钮loading
      reply: '', // 自动回复
      leavingText: '', // 广告留言
      successDialogFlag: false, // 成功后的提示
      precent: '',
      blance: '--', // 开启法币汇率时可用余额,
      otcRateFlag: false, // 是否开启法币汇率配置
      otcRateList: [], // 对应法币汇率列表
      countryList: [],
      countryCode: '',
    };
  },
  computed: {
    // 失效时间列表
    daysList() {
      const day = this.$t('otcRelease.day');
      return [
        { value: `2${day}`, code: '2' },
        { value: `4${day}`, code: '4' },
        { value: `7${day}`, code: '7' },
        { value: `30${day}`, code: '30' },
      ];
    },
    pricentMethodList() {
      return [
        { value: this.$t('otcRelease.higher'), code: '1' },
        { value: this.$t('otcRelease.lower'), code: '2' },
      ];
    },
    // 定价方式列表
    pricingMethodList() {
      return [
        // 市场价(溢价)
        { value: this.$t('otcRelease.MarketPrice'), code: '1' },
        // 自定义
        { value: this.$t('otcRelease.Custom'), code: '2' },
      ];
    },
    rateUrl() {
      let url = '';
      if (this.otcPublicInfo && this.otcPublicInfo.rateUrl) {
        url = this.otcPublicInfo.rateUrl;
      }
      return url;
    },
    confirmDisabled() {
      let flag = true;
      let priceF = true;
      if (this.pricingMethod === '2') {
        priceF = this.autoPriceObj.flag;
      }
      let payF = false;
      if (this.side === 'SELL') {
        payF = this.mySellPaysList.length;
      } else {
        payF = this.myBuyPaysList.length;
      }
      if (
        (this.symbol
          && this.side.length
          && this.legalCurrency.length
          && this.numberObj.flag
          && priceF
          && this.precentObj.flag
          && this.minPriceObj.flag
          && this.maxPriceObj.flag
          && this.tradeTimeObj.flag
          && this.frequencyFlag
          && this.days.length
          && this.countryCode
          && payF)
        || this.confirmLoading
      ) {
        flag = false;
      }
      return flag;
    },
    precentPrice() {
      const precent = this.precent === '' ? 0 : this.precent;
      let price = '--';
      if (this.nowPrice !== '--') {
        if (this.pricentMethod === '1') {
          price = fixD(this.nowPrice * (1 + window.parseFloat(precent) / 100), this.priceFix);
        } else {
          price = fixD(this.nowPrice * (1 - window.parseFloat(precent) / 100), this.priceFix);
        }
      }
      return price;
    },
    sum() {
      let sum = 0;
      if (this.number) {
        if (this.pricingMethod === '1') {
          sum = this.number * this.precentPrice;
        } else {
          sum = this.number * this.autoPrice;
        }
      }
      return fixD(sum, this.priceFix);
    },
    priceFix() {
      let fix = this.$store.state.baseData.defaultFiatPrecision;
      if (
        this.market
        && this.market.coinList[this.showSymbol]
        && this.market.coinList[this.showSymbol].fiatPrecision
        && this.market.coinList[this.showSymbol].fiatPrecision[this.legalCurrency.toLowerCase()]
      ) {
        fix = this.market.coinList[this.showSymbol].fiatPrecision[this.legalCurrency.toLowerCase()];
      }
      return Number(fix);
    },
    // 当前单价
    nowPrice() {
      let price = '--';
      if (
        this.rates
        && this.rates.symbol === this.showSymbol
        && this.market
        && this.market.coinList
      ) {
        const fix = this.priceFix;
        const nowP = this.rates[this.legalCurrency];
        price = fixD(nowP, fix);
      }
      return price;
    },
    market() {
      return this.$store.state.baseData.market;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    otcPublicInfo() {
      return this.$store.state.baseData.otcPublicInfo;
    },
    frequencyFlag() {
      if (this.frequency.length === 0) {
        return false;
      }
      return true;
    },
    // 数量输入框 验证
    numberObj() {
      if (this.number.length === 0 && (this.minPrice.length !== 0 || this.maxPrice.length !== 0)) {
        return {
          flag: false,
          errorFlag: true,
          // 请输入数量
          errorText: this.$t('otcRelease.PleaseEnterQuantity'),
        };
      }
      if (this.side === 'SELL') {
        if (this.number.length === 0) {
          return {
            flag: false,
            errorFlag: false,
            // 请输入数量
            errorText: this.$t('otcRelease.PleaseEnterQuantity'),
          };
        }
        if (parseFloat(this.number) === 0) {
          return {
            flag: false,
            errorFlag: true,
            // 请输入数量
            errorText: this.$t('otcRelease.PleaseEnterQuantity'),
          };
        }
        if (parseFloat(this.numberValue) >= parseFloat(this.number)) {
          return {
            flag: true,
            errorFlag: false,
            errorText: '',
          };
        }
        if (parseFloat(this.numberValue) < parseFloat(this.number)) {
          return {
            flag: false,
            errorFlag: true,
            // 可用余额不足
            errorText: this.$t('otcRelease.availableBalance'),
          };
        }
        return {
          flag: false,
          errorFlag: false,
          errorText: '',
        };
      }
      if (this.number.length === 0 || parseFloat(this.number) === 0) {
        return {
          flag: false,
          errorFlag: false,
          errorText: '',
        };
      }
      return {
        flag: true,
        errorFlag: false,
        errorText: '',
      };
    },
    // 自定义价格 验证
    autoPriceObj() {
      if (this.autoPrice.length === 0 || parseFloat(this.autoPrice) === 0) {
        return {
          flag: false,
          errorFlag: false,
          errorText: '',
        };
      }
      return {
        flag: true,
        errorFlag: false,
        errorText: '',
      };
    },
    // 百分比验证
    precentObj() {
      if (this.precent > 50) {
        return {
          flag: false,
          errorFlag: true,
          errorText: this.$t('otcRelease.precentError'),
        };
      }
      return {
        flag: true,
        errorFlag: false,
        errorText: '',
      };
    },
    // 最小限额 验证
    minPriceObj() {
      if (this.minPrice.length === 0 || parseFloat(this.minPrice) === 0) {
        return {
          flag: false,
          errorFlag: false,
          errorText: '',
        };
      }
      if (parseFloat(this.minPrice) > parseFloat(this.sum)) {
        return {
          flag: false,
          errorFlag: true,
          // 最小限额不得大于总金额
          errorText: this.$t('otcRelease.minPriceError1'),
        };
      }
      if (parseFloat(this.minPrice) >= parseFloat(this.maxPrice)) {
        return {
          flag: false,
          errorFlag: true,
          // 最小限额不得大于或等于最大限额
          errorText: this.$t('otcRelease.minPriceError2'),
        };
      }
      return {
        flag: true,
        errorFlag: false,
        errorText: '',
      };
    },
    // 最大限额 验证
    maxPriceObj() {
      if (this.maxPrice.length === 0 || parseFloat(this.maxPrice) === 0) {
        return {
          flag: false,
          errorFlag: false,
          errorText: '',
        };
      }
      if (parseFloat(this.maxPrice) > parseFloat(this.sum)) {
        return {
          flag: false,
          errorFlag: true,
          // 最大限额不得大于总金额
          errorText: this.$t('otcRelease.maxPriceError1'),
        };
      }
      if (parseFloat(this.minPrice) >= parseFloat(this.maxPrice)) {
        return {
          flag: false,
          errorFlag: true,
          // 最大限额不得小于或等于最小限额
          errorText: this.$t('otcRelease.maxPriceError2'),
        };
      }
      return {
        flag: true,
        errorFlag: false,
        errorText: '',
      };
    },
    // 付款时限 验证
    tradeTimeObj() {
      if (this.tradeTime.length === 0) {
        return {
          flag: false,
          errorFlag: false,
          // 请输入付款时限
          errorText: this.$t('otcRelease.paymentTimeLimit'),
        };
      }
      if (parseFloat(this.tradeTime) < 10 || parseFloat(this.tradeTime) > 20) {
        return {
          flag: false,
          errorFlag: true,
          // 付款时限应当在 10-20 分钟
          errorText: this.$t('otcRelease.paymentTimeError'),
        };
      }
      return {
        flag: true,
        errorFlag: false,
        errorText: '',
      };
    },
    // 页面上用于展示的交易货币
    showSymbol() {
      let v = '';
      if (this.symbolList.length && typeof this.symbol === 'number') {
        this.symbolList.forEach((item) => {
          if (item.index === this.symbol) {
            v = item.name;
          }
        });
      }
      return v;
    },
    showCoin() {
      let v = this.showSymbol;
      if (this.market && this.market.coinList) {
        v = getCoinShowName(v, this.market.coinList);
      }
      return v;
    },
    // 当前币种可用余额
    numberValue() {
      let v = '--';
      if (
        this.accountList
        && this.accountList.length
        && typeof this.symbol === 'number'
        && this.market
        && this.market.coinList
        && this.otcPublicInfo
        && this.otcPublicInfo.feeOtcList
      ) {
        this.accountList.forEach((item) => {
          if (item.coinSymbol === this.showSymbol) {
            const { normal } = item;
            let symbolRate = 0;
            let fix = 0;
            // 获取手续费
            this.otcPublicInfo.feeOtcList.forEach((citem) => {
              if (citem.symbol === this.showSymbol) {
                symbolRate = citem.rate;
              }
            });
            // 获取精度
            Object.keys(this.market.coinList).forEach((citem) => {
              const { showPrecision, name } = this.market.coinList[citem];
              if (name === this.showSymbol) {
                fix = showPrecision;
              }
            });
            v = fixD(normal / (1 + symbolRate), fix);
          }
        });
      }
      return v;
    },
    excheifFlag() {
      return this.$store.state.baseData.exchief_project_switch;
    },
    navSymbolList() {
      const arr = [];
      if (this.market && this.market.coinList) {
        this.symbolList.forEach((item) => {
          arr.push({
            name: getCoinShowName(item.name, this.market.coinList),
            index: item.index,
          });
        });
      }
      return arr;
    },
    publicInfo() {
      return this.$store.state.baseData.publicInfo;
    },
  },
  watch: {
    showSymbol(v) {
      this.axios({
        url: 'otc/rates',
        method: 'post',
        hostType: 'otc',
        params: {
          symbol: v,
        },
      }).then((data) => {
        if (data.code.toString() === '0') {
          this.rates = data.data;
        }
      });
    },
    userInfo(v) {
      if (v) {
        this.jurisdiction();
        this.initSellPaysList();
        this.isSh();
      }
    },
    // 格式化 数量的输入
    number(v) {
      let fix = 0;
      if (this.market && this.market.coinList && typeof this.symbol === 'number') {
        // 获取精度
        Object.keys(this.market.coinList).forEach((citem) => {
          const { showPrecision, name } = this.market.coinList[citem];
          if (name === this.showSymbol) {
            fix = showPrecision;
          }
        });
        this.number = fixInput(v, fix);
      }
    },
    precent(v) {
      this.precent = fixInput(v, 2);
    },
    // 格式化 自定义价格
    autoPrice(v) {
      const fix = this.priceFix;
      this.autoPrice = fixInput(v, fix);
    },
    // 格式化 最小限额
    minPrice(v) {
      const fix = this.priceFix;
      this.minPrice = fixInput(v, fix);
    },
    // 格式化 最大限额
    maxPrice(v) {
      const fix = this.priceFix;
      this.maxPrice = fixInput(v, fix);
    },
    // 付款期限
    tradeTime(v) {
      this.tradeTime = fixInput(v, 0);
    },
    // 交易次数
    frequency(v) {
      this.frequency = fixInput(v, 0);
    },
    market: {
      immediate: true,
      handler(v) {
        // 构建交易货币列表
        if (v && this.otcPublicInfo) {
          this.init();
        }
      },
    },
    otcPublicInfo: {
      handler(v) {
      // 构件法币列表
        if (v) {
          this.initLegalCurrencyList(); // 初始化法币
          this.side = this.otcPublicInfo.defaultSeach; // 设置默认方向
          this.initBuyPaysList(); // 初始化支付方式列表
          if (this.market) {
            this.initSymbolList();
          }
          this.dataCountry(v.countryNumberInfo);
        }
      },
      immediate: true,
    },
    // publicInfo(publicInfo) {
    //   if (publicInfo) {
    //     console.log('vvv1', this.otcPublicInfo);
    //     if (this.otcPublicInfo) {
    //       // 国家地区数据处理
    //       console.log('vvv2', this.otcPublicInfo);
    //       this.dataCountry(this.otcPublicInfo.countryNumberInfo);
    //     }
    //   }
    // },
  },
  methods: {
    init() {
      if (!this.market || !this.market.coinList) {
        return;
      }
      this.initData();
      // this.getOtcRateList();
      this.precent = '';
    },
    alertClose() {
      this.jurisdictionObj.flag = false;
    },
    alertConfirm() {
      this.$router.push(this.jurisdictionObj.btnLink);
    },
    goNoPay() {
      this.$router.push('/otc/leaglTenderSet');
    },
    isSh() {
      if (this.userInfo.authLevel.toString() !== '1') {
        // alert('请您先实名认证');
        return;
      }
      if (this.userInfo.otcCompanyInfo && this.userInfo.userCompanyInfo) {
        if (this.userInfo.otcCompanyInfo.status !== '0') {
          if (this.userInfo.userCompanyInfo === '0') {
            alert('请您申请成为商户');
          }
        }
      }
    },
    initData() {
      this.getAccountList();
      if (this.market && this.otcPublicInfo) {
        this.initSymbolList();
      }
      if (this.otcPublicInfo) {
        this.initLegalCurrencyList(); // 初始化法币
        this.side = this.otcPublicInfo.defaultSeach; // 设置默认方向
        this.initBuyPaysList(); // 初始化支付方式列表
      }
      if (this.userInfo) {
        this.jurisdiction();
        this.initSellPaysList();
        this.isSh();
      }
    },
    jurisdiction() {
      // const arr = [
      //   { text: '绑定谷歌验证', flag: this.OpenGoogle },
      //   { text: '绑定手机验证', flag: this.OpenMobile },
      // ];
      // let userInfo = {
      //   authLevel: 1,
      //   nickName: '1',
      //   otcCompanyInfo: { status: 1 },
      //   userCompanyInfo: { status: 0 }
      // }
      const data = [];
      // 请完成实名认证，设置昵称才能发布广告
      let str = this.$t('otcRelease.jurisdictionTitle');
      const {
        otcCompanyInfo, userCompanyInfo, nickName, authLevel,
      } = this.userInfo;
      let statusKey = '';
      let btnText = '';
      let btnLink = '';
      let pass = true;
      // 实名认证
      const authentication = this.$t('otcRelease.authentication');
      if (authLevel.toString() === '1') {
        data.push({ text: authentication, flag: true, key: 'authLevel' });
      } else {
        data.push({ text: authentication, flag: false, key: 'authLevel' });
        statusKey = 'authLevel';
        // 去认证
        btnText = this.$t('otcRelease.DeCertification');
        btnLink = '/personal';
        pass = false;
      }
      // 设置昵称
      const SetNickname = this.$t('otcRelease.SetNickname');
      if (nickName && nickName.length) {
        data.push({ text: SetNickname, flag: true, key: 'nickName' });
      } else {
        data.push({ text: SetNickname, flag: false, key: 'nickName' });
        if (!statusKey.length) {
          statusKey = 'nickName';
          // 去设置
          btnText = this.$t('otcRelease.ToSetUp');
          btnLink = '/personal/userManagement';
          pass = false;
        }
      }
      // 申请商户
      if (otcCompanyInfo.status.toString() !== '0') {
        // 请完成实名认证，设置昵称并申请成为商家才能发布广告
        str = this.$t('otcRelease.jurisdictionTitle2');
        const ApplicationMerchant = this.$t('otcRelease.ApplicationMerchant');
        if (userCompanyInfo.status.toString() !== '0') {
          data.push({ text: ApplicationMerchant, flag: true, key: 'companyInfo' });
        } else {
          data.push({ text: ApplicationMerchant, flag: false, key: 'companyInfo' });
          if (!statusKey.length) {
            statusKey = 'companyInfo';
            // 去申请
            btnText = this.$t('otcRelease.ToApply');
            btnLink = '/companyApplication';
            pass = false;
          }
        }
      }
      const obj = {
        data,
        str,
        statusKey,
        btnText,
        btnLink,
        pass,
        flag: !!statusKey.length,
      };
      this.jurisdictionObj = obj;
    },
    inputLineChange(value, name) {
      this[name] = value;
    },
    // 获取列表
    getAccountList() {
      this.axios({
        url: '/finance/otc_account_list',
      }).then((data) => {
        if (data.code.toString() === '0') {
          this.accountList = data.data.allCoinMap;
        }
      });
    },
    // 初始化 数字货币列表
    initSymbolList() {
      const list = [];
      let { coinList } = this.market;

      if (Array.isArray(coinList)) {
        coinList = coinList.sort((a, b) => a.sort - b.sort);
      }

      Object.keys(coinList).forEach((item, index) => {
        if (coinList[item].otcOpen) {
          // getCoinShowName(obj.name, this.market.coinList)
          list.push({ name: item, index: index + 1 });
        }
      });
      this.symbolList = list;
      this.initSymbol();
    },
    // 设置默认的数字货币
    initSymbol() {
      this.symbolList.forEach((item) => {
        if (item.name === this.otcPublicInfo.defaultCoin) {
          this.symbol = item.index;
        }
      });
    },
    // 初始化交易的法币
    initLegalCurrencyList() {
      const list = [];
      this.otcPublicInfo.paycoins.forEach((item) => {
        list.push({ value: item.title, code: item.key });
      });
      this.legalCurrency = this.otcPublicInfo.otcDefaultPaycoin;
      this.legalCurrencyList = list;
    },
    // 初始化支付方式列表
    initBuyPaysList() {
      // this.buyPaysList = this.otcPublicInfo.payments;
    },
    // 初始化收款方式列表
    initSellPaysList() {
      this.axios({
        url: '/otc/payment/find',
        hostType: 'otc',
        params: { isOpen: '1' },
      }).then((data) => {
        if (data.code.toString() === '0') {
          const list = data.data;
          const newList = [];
          const obj = {};
          if (this.excheifFlag) {
            list.forEach((ele, i) => {
              if (!obj[list[i].payment]) {
                newList.push(list[i]);
                obj[list[i].payment] = true;
              }
            });
            this.sellPaysList = newList;
            this.buyPaysList = newList;
          } else {
            this.sellPaysList = list;
            this.buyPaysList = list;
          }
        }
      });
    },
    // 重置 数量/定价方式/最小限额/最大限额/付款时限
    reset() {
      this.number = ''; // 重置数量
      this.pricingMethod = '1'; // 重置定价方式
      this.autoPrice = ''; // 重置自定义价格
      this.minPrice = ''; // 重置最小限额
      this.maxPrice = ''; // 重置最大限额
      this.tradeTime = '10'; // 重置付款时限
      this.frequency = '0'; // 重置交易次数
      this.days = '30'; // 重置失效时间
      this.myBuyPaysList = []; // 重置已选支付方式
      this.mySellPaysList = []; // 重置已选收款方式
      this.leavingText = ''; // 广告留言
      this.reply = '';
      this.countryCode = '';
    },
    // 切换币种
    symbolChange(item) {
      if (this.symbol === item.index) {
        return;
      }
      this.symbol = item.index;
      this.side = this.otcPublicInfo.defaultSeach; // 重置广告类型
      this.legalCurrency = this.otcPublicInfo.otcDefaultPaycoin; // 重置法币
      if (this.otcRateFlag && this.excheifFlag) {
        this.setBlance();
      }
      this.reset();
    },
    // 切换广告类型
    sideChange(name) {
      this.side = name;
      this.legalCurrency = this.otcPublicInfo.otcDefaultPaycoin; // 重置法币
      this.reset();
      if (this.otcRateFlag && this.excheifFlag) {
        this.setBlance();
      }
    },
    // 切换法币
    legalCurrencyChange(item) {
      this.legalCurrency = item.code;
      if (this.otcRateFlag && this.excheifFlag) {
        this.setBlance();
      }
      this.reset();
    },
    // 切换溢价方向
    precentMethodChange(item) {
      this.pricentMethod = item.code;
    },
    // 切换定价方式
    pricingMethodChange(item) {
      this.pricingMethod = item.code;
      this.autoPrice = this.nowPrice;
      this.precent = '';
      this.pricentMethod = '1';
    },
    // 溢价
    barChange(num) {
      this.barNum = Number(num);
    },
    // 切换失效时间
    daysChange(item) {
      this.days = item.code;
    },
    // 支付方式点击
    buyPayClick(item) {
      if (this.myBuyPaysList.indexOf(item.id) !== -1) {
        this.myBuyPaysList.splice(this.myBuyPaysList.indexOf(item.id), 1);
      } else {
        if (this.myBuyPaysList.length >= 3) {
          // 最多可以选择三种支付方式
          this.$bus.$emit('tip', { text: this.$t('otcRelease.threePayment'), type: 'warning' });
          return;
        }
        this.myBuyPaysList.push(item.id);
      }
    },
    // 收款方式点击
    sellPayClick(item) {
      if (this.mySellPaysList.indexOf(item.id) !== -1) {
        this.mySellPaysList.splice(this.mySellPaysList.indexOf(item.id), 1);
      } else {
        this.mySellPaysList.push(item.id);
      }
    },
    confirm() {
      if (!this.jurisdictionObj.pass) {
        this.jurisdictionObj.flag = true;
        return;
      }
      let priceParams = {};
      // 价格
      if (this.pricingMethod === '1') {
        priceParams = {
          price: this.precentPrice,
          priceRate: Math.abs(this.precent),
          priceRateType: this.pricentMethod === '1' ? 2 : 3,
        };
      } else {
        priceParams = {
          price: this.autoPrice,
          priceRate: 0,
          priceRateType: 0,
        };
      }
      const payments = [];
      if (this.side === 'SELL') {
        this.mySellPaysList.forEach((item) => {
          payments.push({
            id: item,
          });
        });
      } else {
        this.myBuyPaysList.forEach((item) => {
          payments.push({
            id: item,
          });
        });
      }
      const params = {
        coin: this.showSymbol, // 交易币种
        side: this.side, // 方向
        payCoin: this.legalCurrency, // 法币
        volume: this.number, // 数量
        ...priceParams, // 价格
        minTrade: this.minPrice, // 最小限额
        maxTrade: this.maxPrice, // 最大限额
        limitTime: this.tradeTime, // 交易期限
        dealVolume: this.frequency, // 交易次数
        days: this.days, // 失效时间
        payments,
        description: this.leavingText,
        autoReply: this.reply,
        numberCode: this.countryCode,
      };
      this.confirmLoading = true;
      this.axios({
        url: 'otc/wanted_save',
        hostType: 'otc',
        params,
      }).then((data) => {
        this.confirmLoading = false;
        if (data.code.toString() === '0') {
          this.successDialogFlag = true;
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    successDialogConfirm() {
      this.initData();
      this.reset();
      this.successDialogFlag = false;
    },
    successDialogClose() {
      this.$router.push('/otc');
    },
    // 获取法币汇率列表及开关
    getOtcRateList() {
      this.axios({
        url: this.$store.state.url.common.otc_fee_rate_list,
      }).then((data) => {
        if (data.code.toString() === '0') {
          this.otcRateFlag = Number(data.data.otc_fee_rate_type) === 2;
          this.otcRateList = data.data.otc_fee_rate_list;
          if (this.otcRateFlag && this.excheifFlag) {
            this.setBlance();
          }
        }
      });
    },
    // 获取对应法币汇率
    setBlance() {
      if (
        this.accountList
        && this.accountList.length
        && typeof this.symbol === 'number'
        && this.market
        && this.market.coinList
        && this.otcPublicInfo
        && this.otcRateList
      ) {
        this.accountList.forEach((item) => {
          if (item.coinSymbol === this.showSymbol) {
            const { normal } = item;
            let symbolRate = 0;
            let fix = 0;
            // 获取手续费
            this.otcRateList.forEach((citem) => {
              if (citem.symbol === this.showSymbol && citem.fiatCoin === this.legalCurrency) {
                symbolRate = citem.rate;
              }
            });
            // 获取精度
            Object.keys(this.market.coinList).forEach((citem) => {
              const { showPrecision, name } = this.market.coinList[citem];
              if (name === this.showSymbol) {
                fix = showPrecision;
              }
            });
            this.blance = fixD(normal / (1 + symbolRate), fix);
          }
        });
      }
    },
    /**
     * 国家地区数据处理
     */
    dataCountry(data) {
      const List = [];
      data.forEach(obj => List.push({ value: obj.title, code: obj.numberCode }));
      this.countryList = List;
      this.countryCode = '';
    },
    countryCurrencyChange(item) {
      this.countryCode = item.code;
    },
    handlePayMethodContent(pay) {
      const {
        payment,
        account,
      } = pay;
      const displayAccount = account.length > 4 ? `***${account.substr(-4)}` : `***${account}`;
      if (payment === 'otc.payment.domestic.bank.transfer') {
        return `${pay.bankName} (${displayAccount})`;
      }
      if (payment === 'otc.payment.thirdParty') {
        return `${pay.accountType.split('.')[2]} (${displayAccount})`;
      }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
.page-otcRelease {
  width: 100%;
  margin: 0 auto;
  border-radius: 6px;

  .noPay {
    font-size: 14px;
    margin-top: 10px;
    cursor: pointer;
  }
  .input-line-warning {
    right: 0;
  }
  // 头部选择币种
  .otcRelease-symbolNav {
    height: 72px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    padding-left: 24px;
    padding-top: 31px;
    box-sizing: border-box;
  }
  // 介绍
  .otcRelease-message {
    border-bottom-width: 1px;
    border-bottom-style: solid;
    padding-left: 24px;
    box-sizing: border-box;

    .otcRelease-message-title {
      margin-top: 40px;
      margin-bottom: 22px;
      font-size: 22px;
      letter-spacing: 0;
    }

    .otcRelease-message-text {
      display: flex;
      align-items: center;
      padding-bottom: 40px;

      .left {
        .text {
          font-size: 14px;
          line-height: 30px;
        }
      }

      .right {
        font-size: 159px;
        width: 450px;
        text-align: center;
      }
    }
  }
  // 主体
  .otcRelease-main {
    padding: 0 24px;
    padding-bottom: 60px;
    box-sizing: border-box;
    .otcRelease-page {
      font-size: 14px;
    }
    // 广告类型
    .otcRelease-side {
      display: flex;
      margin-top: 40px;
      margin-bottom: 24px;

      .otcRelease-page-side {
        font-size: 20px;
        margin-right: 50px;
      }

      .otcRelease-side-first {
        margin-right: 60px;
      }

      .common-redio {
        vertical-align: middle;
      }

      .text {
        font-size: 20px;
        vertical-align: middle;
        margin-left: 8px;
        cursor: pointer;
      }
    }

    .flexWrap {
      display: flex;
      align-items: center;
      gap: 24px;
    }

    // 货币类型
    .otcRelease-legalCurrency {
      width: 447px;
    }

    // 数量 95 -70 = 25
    .otcRelease-number {
      width: 447px;
      margin-top: 24px;

      .input-line-warning {
        right: 0;
      }
    }

    // input的单位
    .otcRelease-input-page {
      line-height: 30px;
    }

    // 当前单价 42 - 24 = 18
    .otcRelease-NowPrice {
      margin-top: 18px;
      margin-bottom: 40px;

      .otcRelease-NowPrice-side {
        .des-icon {
          position: relative;
          margin-left: 10px;
          transition: all 0.3s;

          &:hover {
            span {
              display: block;
            }
          }

          span {
            display: none;
            position: absolute;
            // box-shadow: 0 3px 4px 1px rgba(0, 0, 0, 0.28);
            border-radius: 4px;
            font-size: 12px;
            padding: 8px;
            left: 14px;
            top: 0;
            width: 200px;
            line-height: 24px;
            z-index: 1;
          }
          &:hover {
            span {
              display: inline-table;
            }
          }
        }
      }

      .otcRelease-NowPrice-message {
        font-size: 14px;
        margin-top: 6px;

        .price {
          font-size: 20px;
        }

        .address {
          margin-left: 10px;
        }
      }
    }
    // 定价方式
    .otcRelease-pricingMethod {
      width: 447px;
    }

    // 自定义价格
    .otcRelease-autoPrice {
      width: 447px;
      margin-top: 30px;
    }

    .otcRelease-sum-area {
      margin-bottom: 40px;
    }

    // 总金额
    .otcRelease-sum {
      .otcRelease-sum-price {
        font-size: 20px;
        line-height: 20px;
        margin-top: 7px;
      }
    }
    .MessPrice {
      margin-right: 27px;
    }

    .precentInput {
      margin-top: 28px;
      margin-bottom: 12px;
    }

    // 最大限额 90-70
    .otcRelease-minPrice,
    .otcRelease-maxPrice,
    .otcRelease-tradeTime,
    .otcRelease-frequency,
    .otcRelease-days {
      width: 447px;
    }

    .otcRelease-pays {
      margin-top: 24px;

      .otcRelease-paysList {
        li {
          display: inline-block;
          margin-right: 40px;
          margin-top: 30px;
          user-select: none;
        }

        .common-checkout {
          vertical-align: middle;
          margin-right: 10px;
        }

        .paysList-text {
          cursor: pointer;
          display: inline-block;
          min-width: 50px;
          vertical-align: middle;
          font-size: 14px;
        }
      }
    }
  }
  // 成功后的弹窗
  .success-dialog {
    font-size: 14px;
    padding-bottom: 10px;
  }

  .otcReleaseInputLine {
    /deep/ .input-line-warning {
      right: 0;
      top: 4px;
    }
  }

  .buttonContainerArea {
    text-align: center;
    margin-top: 56px;
  }
}
</style>
